export default function ContactSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-8 md:px-16 lg:px-24 bg-background-50" aria-labelledby="contact-title">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          <div className="lg:w-[40%]">
            <h2 id="contact-title" className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 leading-tight tracking-tight mb-2">
              Get in
            </h2>
            <p className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-600 leading-tight tracking-tight mb-8">
              Touch
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-sm mb-14">
              We are based in Sk&auml;rholmen, Sweden, serving clients with a commitment to technical excellence and long-term partnership.
            </p>

            <div className="space-y-0.5 text-sm md:text-base text-foreground-800 leading-loose">
              <p>Address: Odd Fellowv&auml;gen 7</p>
              <p>City: Sk&auml;rholmen</p>
              <p>Zip: 127 32</p>
              <p>Country: Sweden</p>
              <p>Phone number: +46 731727992</p>
              <p>Email: info@brunydigital.com</p>
            </div>
          </div>

          <div className="lg:w-[60%]">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12">
              <div>
                <p className="font-label text-xs uppercase tracking-[0.15em] text-foreground-400 mb-4">Location</p>
                <div className="space-y-0.5 text-sm text-foreground-700 leading-loose">
                  <p>Odd Fellowv&auml;gen 7</p>
                  <p>Sk&auml;rholmen</p>
                  <p>127 32, Sweden</p>
                </div>
              </div>

              <div>
                <p className="font-label text-xs uppercase tracking-[0.15em] text-foreground-400 mb-4">Contact</p>
                <div className="space-y-0.5 text-sm text-foreground-700 leading-loose">
                  <p>+46 731727992</p>
                  <p>info@brunydigital.com</p>
                </div>
              </div>

              <div>
                <p className="font-label text-xs uppercase tracking-[0.15em] text-foreground-400 mb-4">Focus</p>
                <div className="space-y-0.5 text-sm text-foreground-700 leading-loose">
                  <p>iOS Platform</p>
                  <p>Digital Software</p>
                  <p>System Architecture</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-foreground-200/40">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Bruny Digital AB. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
}